import { Injectable } from '@angular/core';
import { BankingAccountProxy } from '../../proxy';
import { DetailService } from './detail.service';
import { Observable, of } from 'rxjs';
import * as Account from '../../model/account';
import { IGetBankingAccountModelResult } from '../../model/banking-account/iBankingAccountResult.model';
import { IUpdateBankingAccountResponse } from '../../model/banking-account/iUpdateBankingAccountResponse.model';
import { IAccountFundData } from '../../model/banking-account/iAccountFundData';
import { IUpdateBankingAccount } from '../../model/banking-account/iUpdateBankingAccount.model';
import { ICountryModel } from '../../model/banking-account/iCountry.model';
import { ICurrencyModel } from '../../model/banking-account/iCurrency.model';
import { IBankingDeleteAccountModel } from '../../model/banking-account/IBankingDeleteAccountModel.model';
import { ICopyAccountModel } from '../../model/banking-account/ICopyAccount.model';
import { SessionService } from '../session';
import { IDeleteAccountModel } from '../../model/banking-account/IDeleteAccount.model';
import { ICancelApprovalRequest } from '../../model/banking-account/iCancelApprovalRequest.model';

@Injectable()
export class BankingService {

  constructor(private detailService: DetailService,
              private bankingProxy: BankingAccountProxy,
              private _sessionService: SessionService) {

  }

  getBankingInvestorAccounts(): Observable<Account.IProfile[]> {
    return this.detailService.getAuthorizedAccounts(null);
  }

  getBankingAccounts(accountIds: number[]): Observable<IGetBankingAccountModelResult> {
    return this.bankingProxy.getBankingAccounts(accountIds);
    //.pipe(map((result) => {
      // result.result.forEach(acct => {
      //   acct.isKBAEnabled = acct.isKBAEnabled && (acct.primaryBankAccount?.accountNumber !== null || acct.primaryBankAccount?.iban !== null);
      // });
      // return result;
    //}));
  }

  getFundBankAccountInfo(accountIds?: number[]): Observable<IAccountFundData[]>{
    return this.bankingProxy.getFundBankAccountInfo(accountIds);
  }

  updateBankingAccounts(accounts: IUpdateBankingAccount): Observable<IUpdateBankingAccountResponse>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    return this.bankingProxy.updateBankAccounts(accounts);
  }

  deleteBankingAccount(deleteAccountObj: IDeleteAccountModel): Observable<IBankingDeleteAccountModel>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    return this.bankingProxy.deleteBankAccounts(deleteAccountObj);
  }

  getTaxId(bankAccountIds: number[]): Observable<boolean> {
    return this.bankingProxy.getTaxId(bankAccountIds);
  }

  createBankAccount(accounts: IUpdateBankingAccount): Observable<IUpdateBankingAccountResponse>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    return this.bankingProxy.createBankAccount(accounts);
  }

  updateOrCreateAccounts(accounts: IUpdateBankingAccount, isUpdateAccount: boolean): Observable<IUpdateBankingAccountResponse>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    if (isUpdateAccount) {
      return this.bankingProxy.updateBankAccounts(accounts);
    } else {
      return this.bankingProxy.createBankAccount(accounts);
    }
  }

  getBankAccountCountries(): Observable<ICountryModel[]> {
    return this.bankingProxy.getBankAccountCountries();
  }

  getBankAccountCurrencies(): Observable<ICurrencyModel[]> {
    return this.bankingProxy.getBankAccountCurrencies();
  }

  cancelBankAccountRequest(cancelObj: ICancelApprovalRequest): Observable<IUpdateBankingAccountResponse>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    return this.bankingProxy.cancelBankAccountRequest(cancelObj);
  }

  uploadFiles(files: File[]): Observable<any>{
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    if (files.length) {
      return this.bankingProxy.uploadFiles(files);
    } else {
      return of({type: 4});
    }
  }

  copyBankAccounts(copiedBankAccounts: ICopyAccountModel){
    if (this._sessionService.isShadow()) {
      return this.bankingProxy.getShadowUserDefaultObservable();
    }

    return this.bankingProxy.copyBankAccountDetails(copiedBankAccounts);
  }

}
